import Home from "../assetsV2/SideBarImage/Dashbaord.svg";
import Booking from "../assetsV2/SideBarImage/Booking.svg";
import Pos from "../assetsV2/SideBarImage/POS.svg";
import ChannelManager from "../assetsV2/SideBarImage/Channel manager.svg";
import Clients from "../assetsV2/SideBarImage/Clients.svg";
import HouseKeeping from "../assetsV2/SideBarImage/Housekeeping.svg";
import Reports from "../assetsV2/SideBarImage/Reports.svg";
import Party from "../assetsV2/SideBarImage/Party.svg";
import PaymentsSideBarIcon from "../assetsV2/SideBarImage/Payments.svg";
import Expense from "../assetsV2/SideBarImage/Expense.svg";
import Invoice from "../assetsV2/SideBarImage/Invoice.svg";
import ManageStocks from "../assetsV2/SideBarImage/stocks.svg";

import Globe from "../assets/images/svgs/dashboard-sidebar-images/globe.svg";
import ReviewsIcon from "../assetsV2/SideBarImage/Reviews.svg";
import { TranslateText } from "../utils/translation";

// Section keys — used as identifiers in DASHBOARD_NAVIGATION_OPTIONS
// and as keys in NAVIGATION_SECTIONS.
export const NAV_SECTIONS = {
  ANALYTICS:     "ANALYTICS",
  FRONT_OFFICE:  "FRONT_OFFICE",
  POINT_OF_SALE: "POINT_OF_SALE",
  ACCOUNTS:      "ACCOUNTS",
  DISTRIBUTION:  "DISTRIBUTION",
};

// Ordered list of sections with their display labels and representative icons.
// `icon` is shown in the collapsed sidebar instead of all individual item icons.
// The order here determines the order in which sections appear in the sidebar.
//
// Sections with a single item (e.g. DASHBOARD) are rendered without an
// accordion — the item is always visible and navigates directly on click.
export const NAVIGATION_SECTIONS = [
  { key: NAV_SECTIONS.ANALYTICS,    label: "Analytics",    icon: Home    },
  { key: NAV_SECTIONS.FRONT_OFFICE, label: "Front Office", icon: Booking },
  { key: NAV_SECTIONS.POINT_OF_SALE, label: "Point of Sale", icon: Pos   },
  { key: NAV_SECTIONS.ACCOUNTS,     label: "Accounts",     icon: Invoice },
  { key: NAV_SECTIONS.DISTRIBUTION, label: "Distribution", icon: ChannelManager },
];

export const DASHBOARD_NAVIGATION_OPTIONS = [
  // ── Analytics ─────────────────────────────────────────────────
  {
    id: "1",
    title: "Dashboard",
    img: Home,
    defaultImg: Home,
    link: "",
    jsx: "Home",
    section: NAV_SECTIONS.ANALYTICS,
    translatedTitle: <TranslateText textKey={"dashboard"} namespace="menu" />,
  },
  {
    id: "11",
    title: "Reports",
    img: Reports,
    defaultImg: Reports,
    link: "reports",
    section: NAV_SECTIONS.ANALYTICS,
    translatedTitle: <TranslateText textKey={"reports"} namespace="menu" />,
  },

  // ── Front Office ──────────────────────────────────────────────
  {
    id: "2",
    title: "Bookings",
    img: Booking,
    defaultImg: Booking,
    link: "bookings",
    section: NAV_SECTIONS.FRONT_OFFICE,
    translatedTitle: <TranslateText textKey={"bookings"} namespace="menu" />,
  },
  {
    id: "8",
    title: "Housekeeping",
    img: HouseKeeping,
    defaultImg: HouseKeeping,
    link: "house-keeping",
    section: NAV_SECTIONS.FRONT_OFFICE,
    translatedTitle: (
      <TranslateText textKey={"housekeeping"} namespace="menu" />
    ),
  },
  {
    id: "6",
    title: "Clients",
    img: Clients,
    defaultImg: Clients,
    link: "clients",
    section: NAV_SECTIONS.FRONT_OFFICE,
    translatedTitle: <TranslateText textKey={"clients"} namespace="menu" />,
  },

  // ── Point of Sale ─────────────────────────────────────────────
  {
    id: "3",
    title: "POS",
    img: Pos,
    defaultImg: Pos,
    link: "all-orders",
    section: NAV_SECTIONS.POINT_OF_SALE,
    translatedTitle: <TranslateText textKey={"pos"} namespace="menu" />,
  },
  {
    id: "16",
    title: "Manage Stocks",
    img: ManageStocks,
    defaultImg: ManageStocks,
    link: "manageStocks",
    section: NAV_SECTIONS.POINT_OF_SALE,
    translatedTitle: (
      <TranslateText textKey={"manage_stocks"} namespace="menu" />
    ),
  },

  // ── Accounts ──────────────────────────────────────────────────
  {
    id: "15",
    title: "Invoice",
    img: Invoice,
    defaultImg: Invoice,
    link: "invoice",
    section: NAV_SECTIONS.ACCOUNTS,
    translatedTitle: <TranslateText textKey={"invoice"} namespace="menu" />,
  },
  {
    id: "13",
    title: "Payments",
    img: PaymentsSideBarIcon,
    defaultImg: PaymentsSideBarIcon,
    link: "payments",
    section: NAV_SECTIONS.ACCOUNTS,
    translatedTitle: <TranslateText textKey={"payments"} namespace="menu" />,
  },
  {
    id: "12",
    title: "Ledger",
    img: Party,
    defaultImg: Party,
    link: "party",
    section: NAV_SECTIONS.ACCOUNTS,
    translatedTitle: <TranslateText textKey={"ledger"} namespace="menu" />,
  },
  {
    id: "14",
    title: "Expense",
    img: Expense,
    defaultImg: Expense,
    link: "expense",
    section: NAV_SECTIONS.ACCOUNTS,
    translatedTitle: <TranslateText textKey={"expense"} namespace="menu" />,
  },

  // ── Distribution ──────────────────────────────────────────────
  {
    id: "5",
    title: "Channel Manager",
    img: ChannelManager,
    defaultImg: ChannelManager,
    link: "channel-manager",
    section: NAV_SECTIONS.DISTRIBUTION,
    translatedTitle: (
      <TranslateText textKey={"channel_manager"} namespace="menu" />
    ),
  },
  {
    id: "17",
    title: "Booking Engine",
    img: Globe,
    defaultImg: Globe,
    jsx: "booking-engine",
    link: "booking-engine",
    section: NAV_SECTIONS.DISTRIBUTION,
    translatedTitle: (
      <TranslateText textKey={"booking_engine"} namespace="menu" />
    ),
  },
  {
    id: "18",
    title: "Reviews",
    img: ReviewsIcon,
    defaultImg: ReviewsIcon,
    link: "reviews",
    section: NAV_SECTIONS.DISTRIBUTION,
    translatedTitle: (
      <TranslateText textKey={"reviews"} namespace="menu" />
    ),
  },

];

export const BillingSettingHeading = "Billing & Subscription";
